angular.module('st')
    .controller('registerAccountController', [
        '$rootScope', '$scope', '$http', '$sce',
        function ($rootScope, $scope, $http, $sce) {
            var ctrl = this;

            var numberOfYears = (new Date()).getYear() - 8;
            $scope.Years = $.map($(Array(numberOfYears)), function (val, i) { return i + 1900; }).reverse();
            $scope.Months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            $scope.Days = $.map($(Array(31)), function (val, i) { return i + 1; });
            $scope.NumberOfDays = 31;
            $scope.findFormFeedback = '';
            $scope.findFormProcessing = false;
            $scope.accountFound = false;
            $scope.findFormModel = {};
            $scope.regFormModel = {};

            ctrl.init = function (redirectToUrl) {
                $scope.redirectToUrl = redirectToUrl;

                $('input[name="memberNumber"]').on('keypress change', function () {
                    $(this).val(function (index, value) {
                        return value.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ');
                    });
                    $(this).val($(this).val().length > 19 ? $(this).val().trim() : $(this).val());
                });
                
                $('input[name="phoneNumber"]').each(function () {
                    $(this).on("change keyup paste", function (e) {
                        var output,
                            $this = $(this),
                            input = $this.val();

                        if (e.keyCode != 8) {
                            input = input.replace(/[^0-9]/g, '');
                            var area = input.substr(0, 3);
                            var pre = input.substr(3, 3);
                            var tel = input.substr(6, 4);
                            if (area.length < 3) {
                                output = "(" + area;
                            } else if (area.length == 3 && pre.length < 3) {
                                output = "(" + area + ")" + " " + pre;
                            } else if (area.length == 3 && pre.length == 3) {
                                output = "(" + area + ")" + " " + pre + "-" + tel;
                            }
                            $this.val(output);
                        }
                    });
                });
            }

            ctrl.IsLeapYear = function (selectedYear) {
                var year = selectedYear || 0;
                return ((year % 400 == 0 || year % 100 != 0) && (year % 4 == 0)) ? 1 : 0;
            }

            ctrl.GetNumberOfDaysInMonth = function (selectedMonth) {
                return 31 - ((selectedMonth === 2) ? (3 - ctrl.IsLeapYear($scope.regFormModel.DobYear)) : ((selectedMonth - 1) % 7 % 2));
            }

            ctrl.UpdateNumberOfDays = function () {
                $scope.NumberOfDays = ctrl.GetNumberOfDaysInMonth($scope.regFormModel.DobMonth);
            }

            ctrl.IsFieldInvalid = function (field, form) {
                return field.$invalid && (field.$touched || form.$submitted);
            }
            
            ctrl.SubmitFindAcctForm = function () {
                $scope.findFormProcessing = true;
                $scope.findFormFeedback = 'Processing...';
                $scope.accountAlreadyRegistered = false;

                var url = "/rpc/membership/find-account";
                var memberNumber = $scope.findFormModel.MemberNumber.split(' ').join('');
                var phoneNumber = $scope.findFormModel.PhoneNumber.replace(/\D/g, '');
                var payload = { CardNumber: memberNumber, PhoneNumber: phoneNumber };

                console.log('find acct form payload:')
                console.log(payload)

                grecaptcha.ready(function () {
                    grecaptcha.execute($('#captcha-site-key').val(), { action: 'crewards_find_account' }).then(function (token) { 
                        payload.captchaToken = token
                        $http.post(url, payload)
                            .then(function (data) {
                                if (data.data.Success == true) {
                                    var accountInfo = data.data.Data;
                                    $scope.findFormFeedback = '';
                                    $scope.findFormProcessing = false;

                                    
                                    if (accountInfo.DateOfBirth) {
                                        //original way of stopping a linked account, Vanessa said to remove (3/7/2024) for now due to bug with DOB being entered at cinema sometimes
                                        //$scope.accountAlreadyRegistered = true;
                                        //return;
                                    } 

                                    $scope.accountFound = true;
                                    $scope.regFormModel.CardNumber = accountInfo.RewardsMemberNumber;
                                    $scope.regFormModel.PhoneNumber = accountInfo.PhoneNumber;
                                    $scope.regFormModel.FirstName = accountInfo.FirstName;
                                    $scope.regFormModel.LastName = accountInfo.LastName;
                                    $scope.regFormModel.Email = accountInfo.Email;
                                } else {
                                    // vista error
                                    $scope.findFormProcessing = false;
                                    $scope.findFormFeedback = 'Error: ' + data.data.Message;
                                }
                            }).catch(function (error) {
                                // our server error
                                $scope.findFormProcessing = false;
                                $scope.findFormFeedback = 'Error occurred while trying to submit the form.'
                            })
                    });
                }); 
            };

            ctrl.SubmitRegisterForm = function () {

                $scope.regFormProcessing = true;
                $scope.regFormFeedback = 'Processing...';

                var url = "/rpc/membership/register";

                console.log('regFormModel')
                console.log($scope.regFormModel)

                grecaptcha.ready(function () {
                    grecaptcha.execute($('#captcha-site-key').val(), { action: 'crewards_register_account' }).then(function (token) { 
                        $scope.regFormModel.captchaToken = token; 
                        $http.post(url, $scope.regFormModel)
                            .then(function (data) {
                                if (data.data.Success == true) {
                                    $scope.regFormFeedback = '';
                                    $scope.regFormProcessing = false;
                                    window.location.href = $scope.redirectToUrl;
                                } else {
                                    // vista error
                                    $scope.regFormProcessing = false;
                                    $scope.regFormFeedback = 'Error: ' + data.data.Message;
                                }
                            }).catch(function (error) {
                                // our server error
                                $scope.regFormProcessing = false;
                                $scope.regFormFeedback = 'Error occurred while trying to submit the form.'
                            })
                    });
                }); 
            };
        }
    ]);
